import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Card,
  Divider
} from "@mui/material";
import { calculateAdlScore } from "../utils/adlUtils";

const ADL_QUESTIONS = [
  {
    key: "feeding",
    label: "1. Feeding : การรับประทานอาหาร",
    options: [
      { value: 0, label: "0 : ต้องมีคนป้อน" },
      { value: 1, label: "1 : ทำเองได้บ้าง ต้องช่วย" },
      { value: 2, label: "2 : ทำได้ปกติ" }
    ]
  },
  {
    key: "grooming",
    label: "2. Grooming : ล้างหน้า แปรงฟัน หวีผม",
    options: [
      { value: 0, label: "0 : ต้องการความช่วยเหลือ" },
      { value: 1, label: "1 : ทำเองได้" }
    ]
  },
  {
    key: "transfer",
    label: "3. Transfer : ลุกย้ายตัว",
    options: [
      { value: 0, label: "0 : ไม่สามารถนั่งได้" },
      { value: 1, label: "1 : ต้องช่วยมาก" },
      { value: 2, label: "2 : ต้องช่วยเล็กน้อย" },
      { value: 3, label: "3 : ทำได้เอง" }
    ]
  },
  {
    key: "toilet_use",
    label: "4. Toilet use : การใช้ห้องน้ำ",
    options: [
      { value: 0, label: "0 : ช่วยตัวเองไม่ได้" },
      { value: 1, label: "1 : ทำได้บ้าง" },
      { value: 2, label: "2 : ทำได้ดี" }
    ]
  },
  {
    key: "mobility",
    label: "5. Mobility : การเคลื่อนที่",
    options: [
      { value: 0, label: "0 : เคลื่อนไหวไม่ได้" },
      { value: 1, label: "1 : ใช้รถเข็นได้เอง" },
      { value: 2, label: "2 : เดินได้มีคนช่วย" },
      { value: 3, label: "3 : เดินได้เอง" }
    ]
  },
  {
    key: "dressing",
    label: "6. Dressing : การแต่งกาย",
    options: [
      { value: 0, label: "0 : ต้องมีคนสวมให้" },
      { value: 1, label: "1 : ช่วยตัวเองได้ครึ่งหนึ่ง" },
      { value: 2, label: "2 : ทำได้เอง" }
    ]
  },
  {
    key: "stairs",
    label: "7. Stairs : การขึ้นลงบันได",
    options: [
      { value: 0, label: "0 : ทำไม่ได้" },
      { value: 1, label: "1 : ต้องการคนช่วย" },
      { value: 2, label: "2 : ขึ้นลงได้เอง" }
    ]
  },
  {
    key: "bathing",
    label: "8. Bathing : การอาบน้ำ",
    options: [
      { value: 0, label: "0 : ต้องมีคนช่วย" },
      { value: 1, label: "1 : อาบน้ำเองได้" }
    ]
  },
  {
    key: "bowels",
    label: "9. Bowels : การกลั้นอุจจาระ",
    options: [
      { value: 0, label: "0 : กลั้นไม่ได้" },
      { value: 1, label: "1 : กลั้นไม่ได้บางครั้ง" },
      { value: 2, label: "2 : กลั้นได้ปกติ" }
    ]
  },
  {
    key: "bladder",
    label: "10. Bladder : การกลั้นปัสสาวะ",
    options: [
      { value: 0, label: "0 : กลั้นไม่ได้" },
      { value: 1, label: "1 : กลั้นไม่ได้บางครั้ง" },
      { value: 2, label: "2 : กลั้นได้ปกติ" }
    ]
  }
];

export default function ADLSection({ adl, setAdl, readOnly = false }) {
  const { total, group, color } = calculateAdlScore(adl);

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" fontWeight="bold">
        แบบประเมิน ADL
      </Typography>

      {ADL_QUESTIONS.map(q => (
        <Card
          key={q.key}
          sx={{
            p: 2,
            my: 2,
            opacity: readOnly ? 0.85 : 1
          }}
        >
          <Typography fontWeight="bold">{q.label}</Typography>

          <RadioGroup
            row
            value={adl[q.key] ?? ""}
            onChange={(e) => {
              if (readOnly) return;
              setAdl(prev => ({
                ...prev,
                [q.key]: Number(e.target.value)
              }));
            }}
          >
            {q.options.map(opt => (
              <FormControlLabel
                key={opt.value}
                value={opt.value}
                control={<Radio disabled={readOnly} />}
                label={opt.label}
              />
            ))}
          </RadioGroup>
        </Card>
      ))}

      <Divider sx={{ my: 2 }} />

      <Box
        sx={{
          p: 2,
          borderRadius: 2,
          backgroundColor: color,
          border: "1px solid",
          borderColor: "divider"
        }}
      >
        <Typography>
          คะแนนรวม: <b>{total}</b> คะแนน
        </Typography>
        <Typography>
          กลุ่มผู้สูงอายุ: <b>{group}</b>
        </Typography>
      </Box>
    </Box>
  );
}
